module.exports = __webpack_public_path__ + "img/subjects.3fabf3a0.png";